@if (LoggedInUser) {
  <div class="reports-page">
    @if (Reports && Reports.length > 0) {
      <section class="reports-page__section">
        <header class="reports-page__head">
          <h2>Reports</h2>
        </header>
        <ul class="reports-page__list">
          @for (report of Reports; track report) {
            <li class="reports-page__row" (click)="generateReport(report)">
              <span class="reports-page__name">{{ report.name }}</span>
              <span class="reports-page__divider"></span>
              <button
                type="button"
                class="reports-page__download"
                [title]="'Download ' + report.name"
                [attr.aria-label]="'Download ' + report.name"
                (click)="generateReport(report); $event.stopPropagation()"
              >
                <i class="bi bi-file-earmark-spreadsheet"></i>
              </button>
            </li>
          }
        </ul>
      </section>
    }

    @if (BusinessReports && BusinessReports.length > 0) {
      <section class="reports-page__section">
        <header class="reports-page__head reports-page__head--split">
          <h2>Business Reports</h2>
          <form
            [formGroup]="BusinessReportOptionsForm"
            class="reports-page__year"
          >
            <select class="form-select form-select-sm" formControlName="year">
              <option [value]="null" disabled selected>Pick a year…</option>
              @for (year of years; track year) {
                <option [value]="year">{{ year }}</option>
              }
            </select>
          </form>
        </header>
        <ul class="reports-page__list">
          @for (report of BusinessReports; track report) {
            <li
              class="reports-page__row"
              (click)="generateBusinessReport(report)"
            >
              <span class="reports-page__name">{{ report.name }}</span>
              <span class="reports-page__divider"></span>
              <button
                type="button"
                class="reports-page__download"
                [title]="'Download ' + report.name"
                [attr.aria-label]="'Download ' + report.name"
                (click)="
                  generateBusinessReport(report); $event.stopPropagation()
                "
              >
                <i class="bi bi-file-earmark-spreadsheet"></i>
              </button>
            </li>
          }
        </ul>
      </section>
    }
  </div>
}
